let translateAMEKE = {
	renameSearch: 'Keresés átnevezése',
	deleteSearch: 'Keresés törlése',
	deleteSearches: 'Keresések törlése',
	deleteSearchQuestion: 'Biztosan törölni szeretné a mentett keresések a listájából?',
	deleteSearchesQuestion: 'Biztosan törölni szeretné az összes mentett keresését?',
	noSearches: 'Önnek jelenleg <strong>nincs mentett keresése</strong>',
	searchesCount: 'Önnek <strong> {{count}} mentett keresése</strong> van a listában',
	deleteAllSavedSearchesButtonText: 'Összes mentett keresés törlése',
	startSearchButtonText: 'Keresés indítása'
};

export default translateAMEKE;
